/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Sync_TitleInputs */

const vi_expense_sync_title = /** @type {(inputs: Expense_Sync_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đồng bộ từ ngân hàng`)
};

/**

* @param {Expense_Sync_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_sync_title = /** @type {((inputs?: Expense_Sync_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Sync_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_sync_title(inputs)
});